 import { styled } from "@mui/material/styles";

 const StyledPaymentSuccess = styled("div")(
   ({ theme }) => `
   .payment-success-logo {
     text-align: center;
     margin: 30px auto;
   }
   .payment-success-text-wrap {
     text-align: center;
     margin: 15% auto;
     display: flex;
     flex-direction: column;
     gap: 20px;
     justify-content: center;
     align-items: center;
     @media screen and (max-width: 700px) {
       margin: 50% auto;
       width: 80%;
     }
   }
     .payment-success-header {
       font-family: Lexend;
       color: ${theme.palette.primary.main};
       font-weight: 400;
       font-size: 20px;
       font-style: normal;
       line-height: 100%;
     }
     .payment-success-btn {
       width: 20%;
       padding: 10px;
       margin-top: 16px;
       font-size: 16px;
       text-transform: none;
       @media screen and (max-width: 700px) {
         width: 60%;
       }
     }    
     `
 );
 
 export default StyledPaymentSuccess;
